export const makeContactLensModelColumns = (contactLensTypeLabels = {}) => [
    {
        Header: 'Model Name',
        accessor: 'modelName',
        enableFilter: true
    },
    {
        Header: 'Manufacturer',
        accessor: row => row.manufacturer?.name || 'N/A',
        id: 'manufacturer',
        enableFilter: true
    },
    {
        Header: 'Material',
        accessor: row => row.material?.name || 'N/A',
        id: 'material'
    },
    {
        Header: 'Lens Type',
        accessor: 'lensType',
        enableFilter: true,
        Cell: ({ value }) => contactLensTypeLabels[value] || value
    },
    {
        Header: 'Trial',
        accessor: 'isTrialAvailable',
        id: 'isTrialAvailable',
        enableFilter: true,
        type: 'enum',
        filterOptions: [
            { value: true, label: 'Yes' },
            { value: false, label: 'No' }
        ],
        Cell: ({ value, row }) => {
            const isYes = Boolean(value);
            const color = isYes ? '#1976d2' : '#9e9e9e';
            const qty = row?.original?.trialQuantity;
            const label = isYes ? `Yes${qty ? ` (${qty})` : ''}` : 'No';
            return <span style={{ color, fontWeight: '600' }}>{label}</span>;
        }
    },

];
